import completedVote from './completedVote';
import activeVote5 from './activeVote5';

let i = 0;
export default () => (i++ % 2 === 0 ? activeVote5 : completedVote);
